import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import ShopDetailsMain from "../Components/Shop/ShopDetailsMain";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";

function ShopDetails() {
  return (
    <>
      <HeaderOne />
      <ShopDetailsMain />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default ShopDetails;
